/**
 * @author: https://www.51xuediannao.com/
 * @update: 2021-09-23 12:02
 */
const _CONFIG = Object.assign({
    "debug": true,
    "host": process.env.VUE_APP_HOST,
    "apiPath": process.env.VUE_APP_API,
    "api":{
        "boss":process.env.VUE_APP_API+"/boss",
		"www":process.env.VUE_APP_API+"/www",
    },
    "apiOSSPath":"https://sharing-activities.oss-cn-beijing.aliyuncs.com/",
    "siteUrl": process.env.VUE_APP_HOST,
    "cdn": "https://sharing-activities.oss-cn-beijing.aliyuncs.com/",
    "rootPath": "",
    "siteName": "Ognibene 量具管理系统",//Ognibene 量具管理系统   欧力量仪校准系统
    "systemFullName": "Ognibene 量具管理系统",//Ognibene 量具管理系统     欧力量仪校准系统
    "shortName": "欧力量仪校准系统",//Ognibene 量具管理系统     欧力量仪校准系统
    "column": [],
    "prefix":"LPF-MN-BOSS",
    "benan":"浙ICP备2024130780号",//浙ICP备2024130780号-2
}, {});

export {_CONFIG}